import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigService } from './config.service';

@Injectable()
export class SwitchService {
  constructor(private http: HttpClient, private configService: ConfigService) {}

  getPendingSwitches(contractNumber: string): Observable<any> {
    const REST_URL = `${this.baseUrl()}/getPendingSwitches`;
    return this.http.get(`${REST_URL}?contractNumber=${contractNumber}`);
  }

  getComplianceOfficerPendingSwitches(username: string): Observable<any> {
    const REST_URL = `${this.baseUrl()}/getComplianceOfficerPendingSwitches`;
    return this.http.get(`${REST_URL}?username=${username}`);
  }

  getComplianceOfficerSwitchHistory(username: string): Observable<any> {
    const REST_URL = `${this.baseUrl()}/getComplianceOfficerSwitchHistory`;
    return this.http.get(`${REST_URL}?username=${username}`);
  }

  approvePendingSwitch(documentId: string): Observable<any> {
    const REST_URL = `${this.baseUrl()}/approvePendingSwitch`;
    return this.http.post(REST_URL, {documentId});
  }

  declinePendingSwitch(documentId: string, feedback: string, username: string): Observable<any> {
    const REST_URL = `${this.baseUrl()}/declinePendingSwitch`;
    return this.http.post(REST_URL, {documentId, feedback, username});
  }

  sendDeclinedEmail(email: string, feedback: string, contractNumber: string, webOwner: string): Observable<any> {
    const REST_URL = `${this.baseUrl()}/sendDeclinedEmail`;
    return this.http.post(REST_URL, {email, feedback, contractNumber, webOwner});
  }

  sendApprovedEmail(email: string, clientAuthType: string, contractNumber: string, webOwner: string): Observable<any> {
    const REST_URL = `${this.baseUrl()}/sendApprovedEmail`;
    return this.http.post(REST_URL, {email, clientAuthType, contractNumber, webOwner});
  }

  sendClientApprovalEmail(email: string): Observable<any> {
    const REST_URL = `${this.baseUrl()}/sendClientApprovalEmail`;
    return this.http.post(REST_URL, {email});
  }

  private baseUrl(): string {
    return `${this.configService.apiUrl()}/switch`;
  }
}
